import { useSelector } from 'react-redux'
import { useQuery } from '@tanstack/react-query'

import { getAuditLogStreamingStatus } from '@/api/auditLogStreaming'
import { selectCurrentEnterprise } from '@/store/features/user/userSlice'

const STATUS_QUERY_KEY = ['audit-log-streaming', 'status']

// staleTime keeps the focus-refetch from firing on every alt-tab; long enough to avoid
// spam, short enough to catch setup completing in the WorkOS tab within a few seconds.
const FOCUS_REFETCH_STALE_TIME_MS = 15_000

export const useStatusQueryKey = () => {
  const enterprise = useSelector(selectCurrentEnterprise)
  // A same-tab account switch (see utils/auth.ts::logout) doesn't reset the react-query
  // cache — scoping by enterprise id keeps a new tenant from seeing the previous one's
  // cached status instead of just an empty static key.
  return [...STATUS_QUERY_KEY, enterprise?.id]
}

export const useAuditLogStreamingStatus = ({ enabled = true }: { enabled?: boolean } = {}) =>
  useQuery({
    queryKey: useStatusQueryKey(),
    queryFn: async () => (await getAuditLogStreamingStatus()).data,
    refetchOnWindowFocus: true,
    staleTime: FOCUS_REFETCH_STALE_TIME_MS,
    enabled,
  })
